// src/modules/app-views/leads/pages/Init/components/tableColumns/landingPageColumn.js
import translateX from 'utils/translateX';

// Displays the data source that captured the lead (name + url).
// Supports both new DataSources ($lookup on dataSourceId) and legacy LandingPages.
function landingPageColumn(buildColumnProps, options = {}) {
  const {
    key = 'landingPageData',
    title = 'data_source',
    dataIndex = 'landingPageData',
    width = 200,
    columnProps = { sort: false },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    className: 'text-truncate',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      // Try DataSource first, fallback to LandingPage data
      const dsData = r?.dataSourceData;
      const lpData = r?.landingPageData;
      const name = dsData?.name || lpData?.name || r?.landingPage || '—';
      const url = dsData?.url || lpData?.url || null;

      return (
        <div className="d-flex flex-column" style={{ maxWidth: width }}>
          <span className="font-weight-semibold">{name}</span>
          {url && (
            <span
              className="text-muted font-size-sm"
              style={{ fontSize: 11, textTransform: 'lowercase' }}
            >
              {url}
            </span>
          )}
        </div>
      );
    },
  };
}

export default landingPageColumn;
